import { PASSENGER_SCENARIO_VEHICLE_PURPOSES } from "../modules/Vehicles/constants";

export const getPropByName = function(obj, name, _default) {
  let p = obj?.properties?.find(prop => (prop.name ?? prop.propertyName)?.name?.toLowerCase() == name?.toLowerCase());
  if (!p) return _default;
  return p.value ?? p.propertyValue?.value ?? _default;
};

export const getPropertyValueObjectByName = function(obj, name, _default, updatedAt) {
  let p = obj?.properties?.find(prop => (prop.name ?? prop.propertyName)?.name == name);
  if (!p) return _default;

  if (updatedAt) return p.updatedAt;
  return p.value ?? p.propertyValue ?? _default;
};

export const getPropIdByName = function(obj, name) {
  let result = obj?.properties.find(prop => (prop.name ?? prop.propertyName).name.toLowerCase() == name.toLowerCase())?.id;
  return result;
};

export const isPassengerVehiclePurposeScenario = (purpose) => PASSENGER_SCENARIO_VEHICLE_PURPOSES.includes(purpose);
